import { ICONS } from '../icons/icons';

export const TAB_ROUTES = [
  {
    label: 'Home',
    icon: ICONS.home,
    path: '/home',
  },
  {
    label: 'Scan',
    icon: ICONS.scan,
    path: '/choose-photo',
  },
  {
    label: 'Settings',
    icon: ICONS.settings,
    path: '/settings',
  },
];
